export default function isValidCnpj(number) {
  let sum = 0;
  let rest;

  // Remove caracteres não numéricos
  number = number?.replace(/\D/g, "");

  // Validações básicas
  if (!number) return false;
  if (number.length !== 14) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1+$/.test(number)) return false;

  // Primeiro dígito verificador
  let weight = 2;
  for (let i = 11; i >= 0; i--) {
    sum += parseInt(number.charAt(i)) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  rest = sum % 11;
  if (rest < 2) {
    rest = 0;
  } else {
    rest = 11 - rest;
  }
  if (rest !== parseInt(number.charAt(12))) return false;

  // Segundo dígito verificador
  sum = 0;
  weight = 2;
  for (let i = 12; i >= 0; i--) {
    sum += parseInt(number.charAt(i)) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  rest = sum % 11;
  if (rest < 2) {
    rest = 0;
  } else {
    rest = 11 - rest;
  }
  if (rest !== parseInt(number.charAt(13))) return false;

  return true;
}
